import { Fab, Tooltip, Zoom } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useRef } from "react";

function getScrollContainer(startEl) {
  let el = startEl?.parentElement;
  while (el) {
    if (el.tagName === "MAIN") return el;
    const { overflowY } = window.getComputedStyle(el);
    if (
      (overflowY === "auto" || overflowY === "scroll") &&
      el.scrollHeight > el.clientHeight
    ) {
      return el;
    }
    el = el.parentElement;
  }
  return document.querySelector("main") || document.documentElement;
}

export function scrollToPageBottom(anchorEl) {
  if (anchorEl) {
    anchorEl.scrollIntoView({ behavior: "smooth", block: "end" });
    return;
  }
  const main = document.querySelector("main");
  if (main) {
    main.scrollTo({ top: main.scrollHeight, behavior: "smooth" });
  } else {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  }
}

const ScrollToBottomFab = () => {
  const anchorRef = useRef(null);

  const handleClick = () => {
    scrollToPageBottom(anchorRef.current);
    const container = getScrollContainer(anchorRef.current);
    if (container) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <span
        ref={anchorRef}
        aria-hidden
        style={{ display: "block", height: 1, width: "100%" }}
      />
      <Zoom in>
        <Tooltip title="En alta in" placement="left">
          <Fab
            color="primary"
            size="medium"
            onClick={handleClick}
            aria-label="Sayfanın en altına git"
            sx={{
              position: "fixed",
              bottom: { xs: 88, sm: 96 },
              right: { xs: 20, sm: 28 },
              zIndex: (theme) => theme.zIndex.speedDial,
              boxShadow: 4,
            }}
          >
            <KeyboardArrowDownIcon />
          </Fab>
        </Tooltip>
      </Zoom>
    </>
  );
};

export default ScrollToBottomFab;
